import useProjectEntriesCall, { toTimestampLike } from './useProjectEntriesCall'

/**
 * @typedef {object} ActivityEntry
 * @property {string} docid - Document-id van de registratie
 * @property {{toDate: () => Date} | null} Timestamp - Zelfde vorm als een Firestore-Timestamp
 * @property {string} Type - Soort registratie ('' als die ontbreekt)
 */

/** @returns {ActivityEntry} */
const toActivityDoc = (/** @type {{id: string, t: number|null, type?: string}} */ entry) => ({
    docid: entry.id,
    Timestamp: toTimestampLike(entry.t),
    Type: entry.type || '',
})

/**
 * De registraties (EventResults) van één project, voor de kaart 'Activiteiten'
 * op de projectdetailpagina, via de Cloud Function `getProjectActivityEntries`.
 * De functie geeft alleen id, tijdstip en soort terug.
 *
 * @param {string} compagnyId - Het project; '' = nog onbekend
 * @returns {{docs: Array<ActivityEntry> | '', error: {code?: string, message?: string} | null, loading: boolean}}
 */
const useProjectActivityEntries = (compagnyId) => useProjectEntriesCall(
    'getProjectActivityEntries', compagnyId, toActivityDoc, 'useProjectActivityEntries'
)

export default useProjectActivityEntries
